import React from 'react';
import Loader from 'react-loader-spinner';

const Loading: React.VFC = () => {
    return <Loader type="Bars" color="#00BFFF" height={40} width={80} timeout={0} />;
};

export default Loading;
